import http from "@/utils/axios";
import { notify } from "@kyvg/vue3-notification";

export default {
  namespaced: true,
  state: {
    discountCodes: [],
    types: [],
    generateCodeTypes: [],
    pagination: {
      currentPage: 1,
      itemsPerPage: 10,
      total: 1,
    },
    discountCode: null,
  },
  getters: {
    getDiscountCodes: (state) => state.discountCodes,
    getTypes: (state) => state.types,
    getGenerateCodeTypes: (state) => state.generateCodeTypes,
    getPagination: (state) => state.pagination,
    getDiscountCode: (state) => state.discountCode,
  },
  mutations: {
    setDiscountCodes(state, payload) {
      state.discountCodes = payload.data;
      state.pagination.currentPage = payload.meta.current_page;
      state.pagination.total = payload.meta.last_page;
    },
    toggleActivePromotion(state, payload) {
      const discountCode = state.discountCodes.find(
        (item) => item.id === payload
      );
      if (discountCode) {
        discountCode["is_active"] = !discountCode["is_active"];
      }
    },
    toggleActiveSlipOfNotepaper(state, payload) {
      const discountCode = state.discountCodes.find(
        (item) => item.id === payload
      );
      if (discountCode) {
        discountCode["has_slip_of_notepaper"] =
          !discountCode["has_slip_of_notepaper"];
      }
    },
    togglePromotionListShow(state, payload) {
      const discountCode = state.discountCodes.find(
        (item) => item.id === payload
      );
      if (discountCode) {
        discountCode["is_list_show"] = !discountCode["is_list_show"];
      }
    },
    togglePromotionCardShow(state, payload) {
      const discountCode = state.discountCodes.find(
        (item) => item.id === payload
      );
      if (discountCode) {
        discountCode["is_card_show"] = !discountCode["is_card_show"];
      }
    },
    setTypes(state, payload) {
      state.types = payload;
    },
    setGenerateCodeTypes(state, payload) {
      state.generateCodeTypes = payload;
    },
    setCurrentPage(state, currentPage) {
      state.pagination.currentPage = currentPage;
    },
    setDiscountCode(state, obj) {
      state.discountCode = obj;
    },
    setItemsPerPage(state, itemsPerPage) {
      state.pagination.itemsPerPage = itemsPerPage;
    },
  },
  actions: {
    async fetchDiscountCodes({ commit, state }, searchTerm = null) {
      const { data } = await http.get(`admin/discount-code`, {
        params: {
          page: state.pagination.currentPage,
          per_page: state.pagination.itemsPerPage,
          search: searchTerm,
        },
      });
      commit("setDiscountCodes", data.discountCodes);
    },
    async fetchDiscountCodeTypes({ commit }) {
      const { data } = await http.get(`admin/discount-code/create`);
      commit("setTypes", data.types);
      commit("setGenerateCodeTypes", data.generateCodeTypes);
    },
    async toggleActivePromotion({ commit }, payload) {
      commit("toggleActivePromotion", payload);
      await http.put(`admin/discount-code/toggle-active/${payload}`);
    },
    async toggleActiveSlipOfNotepaper({ commit }, payload) {
      commit("toggleActiveSlipOfNotepaper", payload);
      await http.put(
        `admin/discount-code/toggle-active-slip-of-notepaper/${payload}`
      );
    },
    async togglePromotionListShow({ commit }, payload) {
      commit("togglePromotionListShow", payload);
      await http.put(
        `admin/discount-code/toggle-promotion-list-show/${payload}`
      );
    },
    async togglePromotionCardShow({ commit }, payload) {
      commit("togglePromotionCardShow", payload);
      await http.put(
        `admin/discount-code/toggle-promotion-card-show/${payload}`
      );
    },
    async downloadCodes({ commit }, url) {
      commit("setLoadingRaports", true);
      return await http({
        url: url,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          commit("clearErrors");
          const filename =
            response.headers["content-disposition"].split("filename=")[1];
          const url = window.URL.createObjectURL(new Blob([response.data]));
          let link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            URL.revokeObjectURL(url);
            link.remove();
          }, 1000);
          commit("setLoadingRaports", false);
        })
        .catch(({ response }) => {
          commit("setLoadingRaports", false);
          if (response && response.status === 422) {
            commit("setErrors", response.data.errors);
            notify({
              type: "danger",
              text: "messages.download.failure",
              duration: 5000,
            });
          } else if (response && response.status === 403) {
            notify({
              type: "danger",
              text: "messages.permission.failure",
              duration: 5000,
            });
            return;
          } else {
            notify({
              type: "danger",
              text: "messages.download.failure",
              duration: 5000,
            });
          }
        });
    },
  },
};
